let html = `<div class="card selector layer--visible layer--render">
    <div class="card__view">
        <img src="./img/img_load.svg" class="card__img" />

        <div class="card__icons">
            <div class="card__icons-inner">
                
            </div>
        </div>
    </div>

    <div class="card__title">{title}</div>
    <div class="card__age">{release_year}</div>
</div>`

export default html